import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class FollowAnimation extends Animation {

    private readonly targetId: string;

    constructor(targetId: string) {
        super();
        this.targetId = targetId;
    }

    public animate(item: SceneItem, context: AnimationContext, cb: () => void): void {
        const target = context.scene.collectFromItems((it, items: SceneItem[]) => {
            if (it instanceof SceneItem && it.animationObj && it.animationObj.id === this.targetId) {
                items.push(it);
            }
        })[0];
        if (target) {
            const dx = item.x - target.x;
            const dy = item.y - target.y;
            const anim = target.animationObj!;
            const isPopUp = anim.ease === "squishStretch";
            const height = item.getLocalBounds().height * 2;
            const onUpdate = () => {
                item.x = target.x + dx;
                item.y = target.y + dy - (isPopUp ? (target.scale.y - 1) * height : 0);
                this.updatePaperCut(item);
            };
            const onComplete = () => {
                anim.onUpdate.remove(onUpdate);
                anim.onComplete.remove(onComplete);
                cb();
            };
            anim.onUpdate.add(onUpdate);
            anim.onComplete.add(onComplete);
        } else {
            cb();
        }
    }
}
